export default "__VITE_ASSET__CU4wmWqy__"